import { useContext, useEffect, useState } from 'react';

import moment from 'jalali-moment';
import queryString from 'query-string';
import { useLocation, useNavigate, useParams } from 'react-router';

import Loading from '../../../Components/Loading/Loading';
import ModalCustom from '../../../Components/Modal/ModalCustom';
import { useApi } from '../../../Hooks/Api';
import { useRole } from '../../../Hooks/Role';
import { useToast } from '../../../Hooks/Toast';
import Master from '../../../Layouts/Master';
import { Step0, Step1, Step2 } from '../Components/Steps';
import Step3 from '../Components/Steps/Step3/Step3';
import { CompetitionRegisterContext } from '../Context/CompetitionRegisterContext';
import { validateSteps } from '../Utils/StepValidation';

const Register = () => {
  const context = useContext(CompetitionRegisterContext);
  const { can } = useRole();
  const { search } = useLocation();
  const params = queryString.parse(search);
  const navigate = useNavigate();
  const { slug } = useParams();
  const { get, post, put } = useApi();
  const { error, success } = useToast();
  const [loading, setLoading] = useState(true);
  const [errors, setErrors] = useState({
    single: {},
    team: {},
    league: {},
    coach: {},
  });
  const [activeNextLevel, setActiveNextLevel] = useState(true);
  const [registerLoading, setRegisterLoading] = useState(false);
  const [confirmModalIsOpen, setConfirmModalIsOpen] = useState(false);
  const [endRegister, setEndRegister] = useState(false);
  const [steps, setSteps] = useState([
    {
      step: 0,
      title: 'توضیحات',
      active: params?.competition_register ? false : true,
    },
    {
      step: 1,
      title: 'ثبت اطلاعات شرکت کنندگان',
      active: params?.competition_register ? true : false,
    },
    {
      step: 2,
      title: 'ثبت اطلاعات سرپرست و مربیان',
      active: false,
    },
    {
      step: 3,
      title: 'بازبینی و تایید نهایی',
      active: false,
    },
  ]);

  useEffect(() => {
    const getData = async () => {
      if (params?.competition_register) {
        await getCompetitionRegister();
      }

      if (!params?.competitionRegister) {
        await checkRegisetrUser();
      }
      await getCompetition();
    };
    getData();
  }, [slug, search]);

  const checkRegisetrUser = async () => {
    setLoading(true);
    await get(
      `/competition-register/competition/${slug}/check-register`,
      (res) => {
        const { data } = res;
        context.checkRegister = data?.register;
      },
      (err) => {
        error('دریافت اطلاعات مسابقه ناموفق بود لطفا دوباره تلاش کنید.');
        setLoading(false);
      },
    );
  };

  const getCompetitionRegister = async () => {
    setLoading(true);
    await get(
      `/competition-register/${params?.competition_register}`,
      (res) => {
        const { data } = res;
        context.competitionRegister = data;
        context.users = data?.users;
        context.teams = data?.teams;
        context.leagues = data?.leagues;
        context.coaches = data?.coaches;
        context.supervisors = data?.supervisors;
        context.province_id = data?.province?.id;
      },
      (err) => {
        error('دریافت اطلاعات مسابقه ناموفق بود لطفا دوباره تلاش کنید.');
        setLoading(false);
      },
    );
  };
  const getCompetition = async () => {
    setLoading(true);
    await get(
      `/competition/show/${slug}`,
      (res) => {
        const { data } = res;
        context.competition = data;
        if (
          (moment(data?.end_register_at).isBefore(moment()) ||
            moment(data?.start_register_at).isAfter(moment())) &&
          !can('Super Admin')
        )
          return navigate('/competition/register');
        setLoading(false);
      },
      (err) => {
        error('دریافت اطلاعات مسابقه ناموفق بود لطفا دوباره تلاش کنید.');
        setLoading(false);
      },
    );
  };
  const getStepActive = () => {
    return steps.find((s) => s.active);
  };

  const nextPrevStep = (prev = false) => {
    if (
      getStepActive()?.step > 0 &&
      !validateSteps(context, getStepActive()?.step, changeErrors) &&
      !prev
    ) {
      console.log('chaaaaaaaa', errors);
      error('لطفا اطلاعات را تکمیل کنید');
      return;
    }

    const stepsCopy = [...steps];
    let currentStep = stepsCopy.findIndex((s) => s.active);
    let index = prev ? currentStep - 1 : parseInt(currentStep) + 1;
    stepsCopy[currentStep]['active'] = false;
    stepsCopy[index]['active'] = true;
    setSteps(stepsCopy);
    context.user = {};
    setActiveNextLevel(prev ? true : false);
  };

  const changeErrors = (type, name, value) => {
    const errorsCopy = { ...errors };
    errorsCopy[type][name] = value;
    setErrors(errorsCopy);
  };

  const register = async () => {
    if (context.province_id === null) {
      error('انتخاب استان الزامی است');
      return;
    }
    setRegisterLoading(true);
    const data = {
      competition_id: context?.competition?.id,
      users: context?.users,
      teams: context?.teams,
      leagues: context?.leagues,
      coaches: context?.coaches.map((c) => c.id),
      supervisors: context?.supervisors.map((s) => s.id),
      province_id: context.province_id ?? null,
      competition_register_id: params.competition_register ?? null,
    };

    let url = params.competition_register
      ? '/competition/register/edit'
      : '/competition/register';
    await post(
      url,
      data,
      (res) => {
        success('ثبت نام شما با موفقیت انجام شد.');
        setEndRegister(true);
        setRegisterLoading(false);
        setConfirmModalIsOpen(false);
        setInterval(() => {
          window.location.href = '/';
        }, 4000);
      },
      (err) => {
        error('درخواست ثبت نام شما با مشکل مواجه شده است.');
        setRegisterLoading(false);
      },
    );
  };

  return loading ? (
    <Loading />
  ) : (
    <Master showSidebar={false} headerFixed={true} containerFullWidth={true}>
      <section className='image-cover pt-4'>
        <div className='container py-5 bg-sky-light shadow-sm rounded-1'>
          <div className='row'>
            <div className='col-12'>
              <h1 className='text-dark f-15 font-weight-bold'>
                {context.competition?.title} - {getStepActive()?.title}
              </h1>
            </div>

            {getStepActive()?.step > 0 && (
              <>
                <div className='col-12 d-none d-md-block'>
                  <div className='d-flex flex-row justify-content-center align-items-center my-3'>
                    <div
                      className='d-flex flex-row align-items-center position-relative'
                      style={{ width: '19%' }}
                    >
                      <div className='d-flex flex-column align-items-center'>
                        <span
                          className={`step-number ${
                            getStepActive()?.step === 1 ||
                            getStepActive()?.step > 1
                              ? 'step-active'
                              : ''
                          }`}
                        >
                          1
                        </span>
                        <span className='step-title mt-2'>
                          {steps.find((s) => s.step === 1)?.title}
                        </span>
                      </div>
                      <div
                        className={`step-divider ${
                          getStepActive()?.step === 1 ||
                          getStepActive()?.step > 1
                            ? 'divider-active'
                            : ''
                        }`}
                        style={{ right: '40%', width: '100%' }}
                      ></div>
                    </div>
                    <div
                      className='d-flex flex-row align-items-center position-relative'
                      style={{ width: '18%' }}
                    >
                      <div className='d-flex flex-column align-items-center'>
                        <span
                          className={`step-number ${
                            getStepActive()?.step === 2 ||
                            getStepActive()?.step > 2
                              ? 'step-active'
                              : ''
                          }`}
                        >
                          2
                        </span>
                        <span className='step-title mt-2'>
                          {steps.find((s) => s.step === 2)?.title}
                        </span>
                      </div>
                      <div
                        className={`step-divider ${
                          getStepActive()?.step === 2 ||
                          getStepActive()?.step > 2
                            ? 'divider-active'
                            : ''
                        }`}
                        style={{ right: '43%', width: '80%' }}
                      ></div>
                    </div>
                    <div
                      className='d-flex flex-row align-items-center position-relative'
                      style={{ width: '15%' }}
                    >
                      <div className='d-flex flex-column align-items-center'>
                        <span
                          className={`step-number ${
                            getStepActive()?.step === 3 ||
                            getStepActive()?.step > 3
                              ? 'step-active'
                              : ''
                          }`}
                        >
                          3
                        </span>
                        <span className='step-title mt-2'>
                          {steps.find((s) => s.step === 3)?.title}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                {endRegister && (
                  <div className='col-12 my-3'>
                    <div className='d-flex flex-row justify-content-center align-items-center bg-success rounded-1 p-2 text-white f-14'>
                      ثبت نام شما با موفقیت انجام شد.
                    </div>
                  </div>
                )}

                <div className='col-12 my-3'>
                  <h1 className='text-dark f-15 font-weight-bold text-left mb-3'>
                    لطفا به نکات زیر توجه کنید :
                  </h1>
                  <p className='text-danger f-15 font-weight-bold text-left'>
                    - لطفا تا پایان مراحل ثبت نام صفحه را رفرش نکنید در صورت
                    رفرش اطلاعات را باید از اول وارد کنید.
                  </p>
                  <p className='text-danger f-15 font-weight-bold text-left'>
                    - لطفا در وارد کردن اطلاعات دقت نمایید مسئولیت ورود اطلاعات
                    اشتباه به عهده شما می باشد.
                  </p>
                </div>
              </>
            )}
          </div>
          {getStepActive()?.step === 0 ? (
            <Step0 context={context} setActiveNextLevel={setActiveNextLevel} />
          ) : getStepActive()?.step === 1 ? (
            <Step1
              errors={errors}
              error={error}
              success={success}
              navigate={navigate}
              get={get}
              context={context}
              setActiveNextLevel={setActiveNextLevel}
            />
          ) : getStepActive()?.step === 2 ? (
            <Step2
              error={error}
              success={success}
              navigate={navigate}
              get={get}
              errors={errors}
              context={context}
              setActiveNextLevel={setActiveNextLevel}
            />
          ) : getStepActive()?.step === 3 ? (
            <Step3
              error={error}
              success={success}
              navigate={navigate}
              get={get}
              context={context}
              setActiveNextLevel={setActiveNextLevel}
            />
          ) : null}
          {(!context.checkRegister && !endRegister) ||
          params?.competition_register !== undefined ? (
            <div className='row'>
              <div className='col-12 my-3'>
                <div className='d-flex flex-row justify-content-center align-items-center'>
                  {getStepActive()?.step > 1 && (
                    <button
                      onClick={() => nextPrevStep(true)}
                      className='btn bg-secondary text-white px-4 py-2 f-13'
                    >
                      مرحله قبل
                    </button>
                  )}

                  <>
                    <button
                      className='btn bg-purple text-white px-4 py-2 f-13 mx-2'
                      onClick={() =>
                        getStepActive()?.step === 3
                          ? setConfirmModalIsOpen(true)
                          : nextPrevStep(false)
                      }
                    >
                      {getStepActive()?.step === 0
                        ? 'شروع ثبت نام'
                        : getStepActive()?.step > 0 && getStepActive()?.step < 3
                        ? ' مرحله بعد'
                        : 'تایید و ثبت نهایی'}
                    </button>
                  </>
                </div>
              </div>
            </div>
          ) : (
            <button className='btn bg-success text-white px-4 py-2 f-13 mx-2 w-100'>
              قبلا ثبت نام شما انجام شده است
            </button>
          )}
        </div>
      </section>
      <ModalCustom modalIsOpen={confirmModalIsOpen}>
        <div className='d-flex flex-row border-bottom pb-2'>
          <i className='fad fa-warning f-20 mx-2'></i>
          <span className=''>آیا از ارسال اطلاعات مطمئن هستید ؟ </span>
        </div>
        <div className='d-flex flex-row justify-content-around my-3'>
          <button
            onClick={() => setConfirmModalIsOpen(false)}
            className='btn btn-danger w-48 f-13'
          >
            لغو
          </button>
          {registerLoading ? (
            <button className='btn btn-success w-48 f-13'>
              <div
                className='spinner-border text-white spinner-border-sm mb-1'
                role='status'
              >
                <span className='sr-only'></span>
              </div>
            </button>
          ) : (
            <button onClick={register} className='btn btn-success w-48 f-13'>
              تایید و ثبت نهایی
            </button>
          )}
        </div>
      </ModalCustom>
    </Master>
  );
};

export default Register;
